var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8097 7.79165C20.8097 10.78 18.6097 13.2458 15.7497 13.6766V13.6216C15.4655 10.065 12.578 7.17748 8.99381 6.89331H8.96631C9.39714 4.03331 11.863 1.83331 14.8513 1.83331C18.1422 1.83331 20.8097 4.50081 20.8097 7.79165Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3744 13.7317C14.1452 10.8258 11.8169 8.4975 8.91107 8.26833C8.75524 8.25917 8.59024 8.25 8.43441 8.25C5.14357 8.25 2.47607 10.9175 2.47607 14.2083C2.47607 17.4992 5.14357 20.1667 8.43441 20.1667C11.7252 20.1667 14.3927 17.4992 14.3927 14.2083C14.3927 14.0525 14.3836 13.8875 14.3744 13.7317ZM9.24107 15.015L8.43441 16.5L7.62774 15.015L6.14274 14.2083L7.62774 13.4017L8.43441 11.9167L9.24107 13.4017L10.7261 14.2083L9.24107 15.015Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.39977e28f5afe3a0cdcc911708cefe69.svg";
export { ForwardRef as ReactComponent };